export default "/images/brand4.png?e7d8f293764a97386bc423feb84fc410";